import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { RemindersComponent } from './reminders/reminders.component';

@NgModule({
  declarations: [
    RemindersComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
  ],
  providers: [],
  exports: [],
  entryComponents: [
    RemindersComponent,
  ],
})

export class ProfileModule {}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/profile/profile.module.ts